import NewsList from "../../components/News/NewsList/NewsList";
import Contact from "../../components/News/Contact/Contact";
import FirstScreen from "../../components/News/FirstScreen/FirstScreen";
import { fetchGlobalData } from "../../utils/utils";
import { useQuery } from "@tanstack/react-query";
import { NewsInternational_Plain } from "../../types/api/news-international.ts";
import { useEffect } from "react";
import { updateSEO } from "../../utils/seo";

const News = ({ locale }: { locale?: string }) => {
  const localeParam = locale ? `&locale=${locale}` : "";
  const {
    data: page,
    error,
    isLoading,
    isError,
  } = useQuery<NewsInternational_Plain>({
    queryKey: [`/api/news-international?customPopulate=nested${localeParam}`],
    queryFn: ({ queryKey }) => fetchGlobalData(queryKey[0] as string),
  });

  useEffect(() => {
    updateSEO(page?.data?.seo); // Canonical will be set even if seo is undefined
  }, [page]);

  if (isLoading) return <div className="loading-block"></div>;
  if (isError) return <div>Error: {error.message}</div>;
  if (!page) return <div>Global error: {page}</div>;

  return (
    <>
      <div className="parallax-content-block">
        <div className="parallax-content-block__wrap">
          <FirstScreen data={page} />
        </div>
      </div>
      <div className="content-block">
        <NewsList locale={locale} />
        <Contact data={page} />
      </div>
    </>
  );
};

export default News;
